function isBrowser() {
  return Boolean(typeof window !== 'undefined' && window._env_)
}
export function blobToBase64(blob: Blob) {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result)
    }
  })
}

export function generateCsv(data: Array<Record<string, any>>, fields: string[]): string {
  let str = ''
  let row = ''

  for (let index in fields) {
    row += fields[index] + ','
  }
  row = row.slice(0, -1)
  str += row + '\r\n'
  for (let i = 0; i < data.length; i++) {
    let line = ''
    for (let field of fields) {
      line += data[i][field] + ','
    }
    line = line.slice(0, -1)
    str += line + (i === data.length - 1 ? '' : '\r\n')
  }

  return str
}

export function checkIfObjectId(id: string): boolean {
  const regex = /^[a-f\d]{24}$/i
  return id.match(regex) ? true : false
}

export function sanitizeSecu(secu: string): string {
  if (isNaN(parseInt(secu))) return secu
  else {
    if (secu.includes('E')) {
      const expoIndex = secu.indexOf('E')
      const val = secu.replace('.', '').substring(0, expoIndex - 1)
      if (val.length === 14) return val + '1'
      return val
    }
    if (secu.length === 15) return secu
    return '000000000000000'
  }
}

export function getEnv(key: string): string | undefined {
  if (isBrowser()) {
    return window._env_[key]
  }

  return import.meta.env[key]
}

export function randomString(length: number) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  const charactersLength = characters.length
  let counter = 0
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }
  return result
}

export function getMinutesFromTimeString(timeString: string) {
  const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/
  if (!timePattern.test(timeString)) {
    throw new Error("Invalid time string format. Please provide time in the format 'HH:mm'.")
  }

  const [hours, minutes] = timeString.split(':').map(Number)
  return hours * 60 + minutes
}

export const setUndefinedIfEmpty = <T>(value: T): T | undefined => (value === '' ? undefined : value)

export const parseIntOrUndefined = (value: string | undefined): number | undefined => (value === '' || value === undefined ? undefined : parseInt(value, 10))

export const transformObject = <T extends Record<string, any>>(obj: T): Partial<T> =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    const transformedValue = setUndefinedIfEmpty(value)
    return transformedValue !== undefined ? { ...acc, [key]: transformedValue } : acc
  }, {} as Partial<T>)

export function isHtmlContent(str: string): boolean {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(
    node => node.nodeType === 1
  );
}